import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import "./Payment.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav";

const Dth = () => {
  const [showTracker, setShowTracker] = useState(false);
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
        <section className="insurance-service position-relative overflow-hidden">
            <div className="container">
              <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: 'relative', height: '100%' }}>
              <SideNav />
            </div>
            </div> */}
            <div className="col-12">
              <div className="row justify-content-center text-center" >
                <div className="col-12">
                  <h2 className="fw-semibold recharge-title">DTH Recharge</h2>
                </div>
              </div>

              <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-8 col-lg-6">
                  <div className="card p-4 shadow mb-5 mt-5 recharge-box">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">DTH Providers</label>
                      <input
                        type="text"
                        className="form-control"
                        list="dthProviders"
                        placeholder="Enter your DTH provider"
                      />
                      <datalist id="dthProviders">
                        <option value="Airtel DTH" />
                        <option value="DISH TV" />
                        <option value="DTH" />
                        <option value="Sun Direct TV" />
                        <option value="Sun Direct TV(Flexi Plans)" />
                        <option value="TATA Play" />
                      </datalist>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">Customer Id / Mobile No / Subscriber Id</label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Enter your mobile number"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Choose Amount / Full Amount
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your amount"
                      />
                    </div>

                    <div className="d-grid">
                      <button className="btn btn-primary" style={{ fontFamily: "poppins" }}>
                        Processed
                      </button>
                    </div>

                    <div className="mt-3" style={{ fontFamily: "poppins" }}>
                      <span>Status Pending?</span>
                      <br />
                      <button
                        className="btn btn-link text-decoration-none text-primary fw-semibold d-inline-flex align-items-center gap-1 p-0"
                        onClick={() => setShowTracker(!showTracker)}
                      >
                        Track Your Status now{" "}
                        <i className="bi bi-arrow-right-short fs-5"></i>
                      </button>

                      {showTracker && (
                        <div className="card p-3 mt-2 shadow-sm">
                          <label className="form-label">Customer ID / Mobile Number</label>
                          <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Enter Number To Track Your Status"
                          />
                          <button
                            className="btn btn-outline-primary"
                            style={{ fontFamily: "poppins" }}
                          >
                            Track Now
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <div
            className="position-absolute bottom-0 start-0 end-0"
            style={{
              height: "25rem",
              background: "linear-gradient(to top, #F5F2FF, transparent)",
              zIndex: "-1",
            }}
          />
          </div>
          </div>
        </section>
      <Explore />
      <Footer />
    </>
  );
};

export default Dth;
